import {useCallback, useEffect, useState} from "react";

const useTableData = ({fetchData}) => {
    const [statsVisible, setStatsVisible] = useState(true);
    const [search, setSearch] = useState("");
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);
                const {current, pageSize} = pagination;
                const {field, order} = sortedInfo;
                const result = await fetchData({current, pageSize, filters: filteredInfo, field, order, search});
                setLoading(false);
                setData(result);
                setPagination(prevPagination => ({
                    ...prevPagination,
                    total: result.total,
                }));

            } catch (error) {
                console.log(error)
            }
        };

        fetchAll();
    }, [pagination.pageSize, pagination.current, filteredInfo, sortedInfo, search])

    const toogleStatsVisible = () => {
        setStatsVisible(prevState => !prevState);
    }

    const handleChange = useCallback((pagination, filters, sorter) => {
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    }, [setFilteredInfo, setSortedInfo]);

    const resetFilters = useCallback(() => {
        setFilteredInfo({});
    }, [setFilteredInfo]);

    const resetSorters = useCallback(() => {
        setSortedInfo({});
    }, [setSortedInfo]);

    const handleSearch = useCallback(({target}) => setSearch(target.value), [setSearch]);

    return {
        search,
        statsVisible,
        filteredInfo,
        sortedInfo,
        data,
        setData,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    }
}

export default useTableData;
